// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28I0a","badges":"styles_badges__328pF"};